import React, { useEffect, useState } from 'react';
import { HanTableContainer, HanTableHead } from '../../../../utils/han-table-components/HanTable';
import University from '../../../../../networking/models/University';
import FormPart from '../../../../../networking/models/FormPart';
import FormQuestionTable from '../../../../utils/han-table-components/FormQuestionTable';

interface IProps {
    children?: any;
    university?: University;
}

const UniversityGeneralAccommodation: React.FC<IProps> = ({ university, children }) => {
    const [accommodation, setAccommodation] = useState<FormPart>();

    useEffect(() => {
        if (university !== undefined) {
            let accommodation = university.formParts?.find(formPart => formPart.name.toLowerCase() === "accommodation");

            if (accommodation !== undefined) setAccommodation(accommodation);
        }
    }, [university]);

    if (accommodation === undefined) return <></>;

    return (
        <div className="university-general__accommodation">
            <h2 className="university-general__accommodation-title">ACCOMMODATION</h2>

            <div className="university-general__accommodation-tables">
                {
                    accommodation.active_questions.map((question, index) => {
                        return (
                            <HanTableContainer key={index}>
                                <HanTableHead>{question.name}</HanTableHead>

                                <FormQuestionTable question={question} />
                            </HanTableContainer>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default UniversityGeneralAccommodation;
